import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';

const styles = {
    formControl: {
        width: '100%'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }
};

const SetDateVerificationDialog = ({ classes, onClickCancel, onClickSave, onChange, reclamationId, date, isAdding }) => (
    <Dialog fullWidth maxWidth={'md'} classes={{ paper: classes.dialogPaper }} open>
        <DialogTitle>
            Modifier la date de vérification du dossier après-vente {reclamationId}
        </DialogTitle>

        <DialogContent className={classes.noScrollable}>

            <FormControl className={classes.formControl}>
                <TextField
                    label="Nouvelle date de vérification"
                    type="date"
                    value={date}
                    onChange={onChange}
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{
                        name: 'newDate',
                        id: 'newDate'
                    }}
                />
            </FormControl>

        </DialogContent>




        <DialogActions>
            <Button onClick={onClickCancel} color="primary" >Annuler</Button>
            <Button
                disabled={isAdding}
                onClick={onClickSave}
                variant="contained"
                color="secondary"
            >
                Enregistrer
                {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
        </DialogActions>
    </Dialog>
);

SetDateVerificationDialog.propTypes = {
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    reclamationId: PropTypes.number.isRequired,
    date: PropTypes.string
};

export default withStyles(styles)(SetDateVerificationDialog);